import React from 'react';
import { useForm } from 'react-hook-form';
import Button from 'components/common/Button';
import StyledInput from 'components/common/StyledInput';
import tw, { styled } from 'twin.macro';
import { useMutation } from 'react-query';
import { getErrorMessage } from 'utils/getErrors';
import { updateStudent } from 'api';
import useAlert from 'hooks/useAlert';

const EditStudent = ({ student, closeModal, refetch }) => {
  const { showError, ShowSuccess } = useAlert();

  const { mutate, isLoading } = useMutation((student) => updateStudent(student), {
    onError: (error) => {
      const message = getErrorMessage(error);
      showError(message);
    },
    onSuccess: () => {
      ShowSuccess('Student updated successfully!');
      closeModal();
      refetch();
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onChange', defaultValues: { ...student } });

  const onFormSubmit = async (data) => {
    mutate(data);
  };

  return (
    <div>
      <StyledForm onSubmit={handleSubmit(onFormSubmit)}>
        <StyledInput
          register={register}
          validation={{ required: 'Full Name is Required!' }}
          error={errors.fullname}
          name='fullName'
          label='Full Name'
          placeholder='Ex: John Doe'
        />
        <div tw='flex space-x-4'>
          <StyledInput
            register={register}
            validation={{ required: 'Address is Required!' }}
            error={errors.address}
            name='address'
            label='Address'
            placeholder='Ex: Dhaka, Bangladesh'
          />
          <StyledInput
            register={register}
            validation={{ required: 'Post Code is Required!' }}
            error={errors.postcode}
            name='postCode'
            label='Post Code'
            placeholder='Ex: 1200'
          />
        </div>
        <div tw='flex space-x-4'>
          <StyledInput
            register={register}
            validation={{ required: 'Instrument is Required!' }}
            error={errors.instrument}
            name='instrument'
            label='Instrument'
            placeholder='Ex: Piano'
          />
          <StyledInput
            register={register}
            validation={{ required: 'Age is Required!' }}
            error={errors.age}
            name='age'
            label='Ages'
            placeholder='Ex: 26'
          />
        </div>
        <div tw='flex space-x-4'>
          <StyledInput
            register={register}
            validation={{ required: 'Phone is Required!' }}
            error={errors.phone}
            name='phone'
            label='Phone'
            placeholder='Ex: +88015418515'
          />
          <StyledInput
            register={register}
            error={errors.message}
            name='message'
            label='message'
            placeholder='Ex: Referred by TM'
          />
        </div>
        <StyledInput
          register={register}
          error={errors.pageTitle}
          name='pageTitle'
          label='page title'
          placeholder='Page name'
        />
        <Button loading={isLoading} text='Update Student' type='submit' />
      </StyledForm>
    </div>
  );
};

export default EditStudent;

const StyledForm = styled.form`
  ${tw`flex flex-col space-y-2.5`}
  button {
    ${tw`w-full`}
  }
`;
